import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwExpressionCompareType, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService,
         DwOrmDataService, DwOrmDataServiceToken, DwMetaDataService, DwMetaDataServiceToken, DwLookupInfo } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, AppMetaDataLookups, DwUserEntity, FlightSchoolOrganizationEntity } from '../../../meta-data/app-meta-data.service';
import { Inject, Injectable } from '@angular/core';
import { SchoolRepositoryService } from '../services/school-repository.service';

@DwCustomContextDefinition({
    keyName: 'SchoolPublicContext',
    display: 'School Public Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.FlightSchoolApplicant
})
@DwCustomContextDefinition({
    keyName: 'SchoolPublicContext_instructor',
    display: 'School Public Context - Instructor',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.FlightSchoolInstructor
})
@Injectable()
export class SchoolPublicContextService extends DwCustomContextBase {

    constructor(
        private schoolRepositoryService: SchoolRepositoryService,
    ){
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            return this.schoolRepositoryService.getCurrentPublicFlightSchool();
        });

        contextDef.item = AppMetaDataItemNames.FlightSchoolOrganization;
        contextDef.useItemMetaData = true;

        // contextDef.attributes = [];
        // var attr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
        //         'FlightSchoolOrganizationId', 'Flight School Organization', 
        //             DwAttributeType.Integer, DwControlType.NumericTextBox);
        
        // attr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
        // attr.Attribute.IsLookup = true;
        // attr.Attribute.MetaDataLookupId = AppMetaDataLookups.AviationTrainingProgramAllItems;
    }

}
